var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadCloud01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 13.5352C2.32769 12.8625 1.66602 11.7168 1.66602 10.4167C1.66602 8.46369 3.15894 6.85941 5.0658 6.68281C5.45586 4.31011 7.51622 2.5 9.99935 2.5C12.4825 2.5 14.5428 4.31011 14.9329 6.68281C16.8398 6.85941 18.3327 8.46369 18.3327 10.4167C18.3327 11.7168 17.671 12.8625 16.666 13.5352M6.66602 14.1667L9.99935 17.5M9.99935 17.5L13.3327 14.1667M9.99935 17.5V10",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud01);
export default __webpack_public_path__ + "static/media/download-cloud-01.b85f878c9ac8476012650e749fe49d69.svg";
export { ForwardRef as ReactComponent };